import React, { useContext } from "react";
import {
	Box,
	Typography,
	TextField,
	Button,
	IconButton,
	Divider,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { CreatorContext } from "../../context/CreatorContext";
import { useTranslation } from "react-i18next";
import { EyeOutline } from "react-ionicons";
import { LogoGoogle, LogoApple } from "react-ionicons";

import LogoBarber from "../../assets/showcases/barber-logo.png";
import LogoSalon from "../../assets/showcases/salon-logo.png";
import LogoTrainer from "../../assets/showcases/trainer-logo.png";
import LogoEcommerce from "../../assets/showcases/ecommerce-logo.png";
import LogoRestaurant from "../../assets/showcases/restaurant-logo.png";
import { UserContext } from "../../context/UserContext";
import chroma from "chroma-js";

const ShowcaseSignIn = ({
	showLogo,
	inputType,
	socialType,
	loginTitle,
	card,
	loginCard,
	loginBorderCard,
	backgroundColor,
}) => {
	const { creator } = useContext(CreatorContext);
	const { user } = useContext(UserContext);
	const { t } = useTranslation();

	const getLogo = (sector) => {
		switch (sector) {
			case "barber":
				return LogoBarber;

			case "salon":
				return LogoSalon;

			case "trainer":
				return LogoTrainer;

			case "ecommerce":
				return LogoEcommerce;

			case "restaurant":
				return LogoRestaurant;
			default:
				return {};
		}
	};

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	const CustomTextField = ({ label, type, multiline }) => {
		console.log(inputType);
		const getDynamicColor = (background) => {
			if (creator.themeMode === "Dark" && inputType === "input3") {
				return chroma(background).brighten(0.4).hex();
			} else if (creator.themeMode === "Light" && inputType === "input3") {
				return chroma(background).darken(0.12).hex();
			} else if (creator.themeMode === "Dark") {
				return chroma(background).brighten(1.5).hex();
			} else {
				return chroma(background).darken(1).hex();
			}
		};

		const backgroundColorDynamic = getDynamicColor(creator.themeColor);
		const borderColor = getDynamicColor(creator.themeColor);
		const placeholderTextColor =
			creator.themeMode === "Dark"
				? chroma(creator.themeColor).brighten(2).hex()
				: chroma(creator.themeColor).darken(2).hex();
		console.log(loginCard);
		console.log(backgroundColor);

		return (
			<Box sx={{ marginBottom: "8px" }}>
				{type === "outline" && (
					<Typography
						sx={{
							fontSize: "7px",
							color: loginCard
								? getTextColorBasedOnBackground(backgroundColor)
								: placeholderTextColor,
							marginBottom: "1px",
						}}
					>
						{label}
					</Typography>
				)}
				{type === "outline" && (
					<Box
						sx={{
							border: `1px solid ${borderColor}`,
							backgroundColor: loginCard ? backgroundColor : creator.themeColor,
							borderRadius: "4px",
							height: multiline ? "200px" : "30px",
							display: "flex",
							alignItems: "flex-start",
							padding: "0 12px",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#C0C0C0",
								marginTop: 1,
							}}
						></Typography>
					</Box>
				)}
				{type === "filled" && (
					<Box
						sx={{
							backgroundColor: backgroundColorDynamic,
							borderRadius: "4px",
							height: multiline ? "200px" : "30px",
							display: "flex",
							padding: "0 12px",
							border: "1px solid transparent",
							alignItems: "flex-start",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: placeholderTextColor,
								marginTop: 1,
							}}
						>
							{label}
						</Typography>
					</Box>
				)}
				{type === "standard" && (
					<Box
						sx={{
							borderBottom: `1px solid ${borderColor}`,
							backgroundColor: "transparent",
							height: multiline ? "200px" : "30px",
							display: "flex",
							padding: "0 0px",
							alignItems: "flex-start",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: placeholderTextColor,
								marginTop: 1,
							}}
						>
							{label}
						</Typography>
					</Box>
				)}
			</Box>
		);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				padding: 1.5,
				color: getTextColorBasedOnBackground(backgroundColor),
				position: "relative",
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{showLogo && (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: loginCard
							? backgroundColor
							: loginBorderCard
							? creator.themeColor
							: "none",
						width: loginCard || loginBorderCard ? 50 : "inherit",
						height: loginCard || loginBorderCard ? 50 : "inherit",
						borderRadius: loginCard || loginBorderCard ? "50%" : "inherit",
						position: loginCard || loginBorderCard ? "absolute" : "inherit",
						top: loginCard || loginBorderCard ? -10 : "inherti",
						left: loginCard || loginBorderCard ? "50%" : "inherit",
						transform:
							loginCard || loginBorderCard ? "translate(-50%, 0%)" : "none",
						zIndex: 1,
						border: loginBorderCard
							? `1px solid ${
									creator.themeMode === "Dark"
										? chroma(creator.themeColor).brighten(1).hex()
										: chroma(creator.themeColor).darken(0.5).hex()
							  }`
							: "none",
					}}
				>
					<img
						src={
							creator.appLogo
								? creator.appLogo
								: getLogo(user?.app?.appSubtype?.toLowerCase() ?? "barber")
						}
						alt={creator.appName}
						style={{
							marginTop: loginCard ? "-14px" : loginBorderCard ? "-5px" : 0,
							width: loginCard || loginBorderCard ? 40 : 60, // Smaller when in card or border mode, larger otherwise
							transition: "all 0.3s ease", // Smooth transition for changes in size
							marginBottom: loginCard || loginBorderCard ? "-4px" : 0, // Adjust based on your exact alignment needs
						}}
					/>
				</Box>
			)}

			<Box
				sx={{
					backgroundColor: loginCard ? backgroundColor : "inherit",
					marginBottom: 0,
					padding: loginCard || loginBorderCard ? 1.5 : 0,
					borderRadius: loginCard || loginBorderCard ? "4px" : 0,
					border: loginBorderCard
						? `1px solid ${
								creator.themeMode === "Dark"
									? chroma(creator.themeColor).brighten(1).hex()
									: chroma(creator.themeColor).darken(0.5).hex()
						  }`
						: "none",
				}}
			>
				<Typography
					variant="h6"
					sx={{
						textTransform: "inherit",
						fontWeight: "normal",
						fontSize: 12,
						marginTop: showLogo && (loginBorderCard || loginCard) ? 3 : 1,
						color: loginCard
							? getTextColorBasedOnBackground(backgroundColor)
							: creator.themeMode === "Dark"
							? "#ffffff"
							: "#000000",
						textAlign: loginCard || loginBorderCard ? "center" : "left",
						overflow: "hidden", // Impide que el contenido desborde
						textOverflow: "ellipsis", // Añade puntos suspensivos si el texto es demasiado largo
						whiteSpace: "nowrap", // Mantiene el texto en una sola línea horizontal
						maxWidth: "100%",
					}}
				>
					{loginTitle}
				</Typography>

				{inputType === "input2" && (
					<Box sx={{ marginTop: 2 }}>
						<CustomTextField label={t("auth.email")} type="outline" />
						<CustomTextField label={t("auth.password")} type="outline" />
					</Box>
				)}
				{inputType === "input3" && (
					<Box sx={{ marginTop: 2 }}>
						<CustomTextField label={t("auth.email")} type="filled" />
						<CustomTextField label={t("auth.password")} type="filled" />{" "}
					</Box>
				)}
				{inputType === "input1" && (
					<Box sx={{ marginTop: 2 }}>
						<CustomTextField label={t("auth.email")} type="standard" />
						<CustomTextField label={t("auth.password")} type="standard" />
					</Box>
				)}

				{/* Enlace de "Forgot Password?" */}
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						width: "100%",
						marginBottom: 1,
					}}
				>
					<Typography
						variant="body2"
						sx={{
							fontSize: "7px",
							color: loginCard
								? getTextColorBasedOnBackground(backgroundColor)
								: creator.themeMode === "Dark"
								? "#ffffff"
								: "#000000",
						}}
					>
						{t("auth.forgotPassword")}
					</Typography>
				</Box>

				{/* Botón de inicio de sesión */}
				<Button
					variant="contained"
					fullWidth
					sx={{
						backgroundColor: creator ? creator.color : "#45A049",
						"&:hover": {
							backgroundColor: creator ? creator.color : "#45A049",
						},
						color: creator && creator.whiteTextButton ? "#ffffff" : "#000000",
						fontSize: "8px",
						borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
						fontWeight: "bold",
						textTransform: "uppercase",
						height: "28px",
						width: "100%",
					}}
				>
					{t("auth.signIn")}
				</Button>

				{/* Divider con "or" */}
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						width: "100%",
						justifyContent: "center",
						textAlign: "center",
						flexDirection: "column",
						marginTop: 1,
					}}
				>
					<Typography
						sx={{
							paddingX: 1,
							fontSize: "7px",
							color: loginCard
								? getTextColorBasedOnBackground(backgroundColor)
								: creator.themeMode === "Dark"
								? "#ffffff"
								: "#000000",
						}}
					>
						or
					</Typography>
					<Typography
						variant="body2"
						sx={{
							fontSize: "7px",
							textAlign: "center",
							marginTop: 0.5,
							marginBottom: 1,
							color: loginCard
								? getTextColorBasedOnBackground(backgroundColor)
								: creator.themeMode === "Dark"
								? "#ffffff"
								: "#000000",
						}}
					>
						{t("auth.noAccount")}
					</Typography>
				</Box>

				<Divider
					sx={{
						marginBottom: 1.5,
						borderColor:
							creator.themeMode === "Dark"
								? chroma(creator.themeColor).brighten(1).hex()
								: chroma(creator.themeColor).darken(0.5).hex(),
					}}
				/>
				{socialType === "socialButton2" && (
					<>
						<Button
							width={"100%"}
							sx={{
								backgroundColor: "#256ceb",
								"&:hover": {
									backgroundColor: "#256ceb",
								},
								color: "#ffffff",
								fontSize: "8px",
								borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "28px",
								width: "100%",
								marginBottom: 0.5,
							}}
							startIcon={
								<LogoGoogle
									width={"10px"}
									height={"10px"}
									style={{
										color: "#ffffff",
										fill: "#ffffff",
										verticalAlign: "middle",
										marginTop: "-5px",
									}}
								/>
							}
						>
							{t("auth.google")}
						</Button>
						<Button
							width={"100%"}
							sx={{
								backgroundColor: "#000000",
								"&:hover": {
									backgroundColor: "#000000",
								},
								color: "#ffffff",
								fontSize: "8px",
								borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "28px",
								width: "100%",
							}}
							startIcon={
								<LogoApple
									width={"10px"}
									height={"10px"}
									style={{
										color: "#ffffff",
										fill: "#ffffff",
										verticalAlign: "middle",
										marginTop: "-5px",
									}}
								/>
							}
						>
							{t("auth.apple")}
						</Button>
					</>
				)}
				{socialType === "socialButton1" && (
					<Box
						sx={{
							display: "flex",
							gap: 1,
							justifyContent: "center",
							padding: 1,
						}}
					>
						<Button
							sx={{
								backgroundColor: "#256ceb",
								"&:hover": {
									backgroundColor: "#256ceb",
								},
								color: "#ffffff",
								fontSize: "8px",
								borderRadius: "50%", // Hace el botón completamente circular
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "30px",
								width: "30px",
								minWidth: "30px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<LogoGoogle
								width={"12px"}
								height={"12p"}
								style={{ fill: "#ffffff", marginTop: "4px" }}
							/>
						</Button>
						<Button
							sx={{
								backgroundColor: "#000000",
								"&:hover": {
									backgroundColor: "#000000",
								},
								color: "#ffffff",
								fontSize: "8px",
								borderRadius: "50%",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "30px",
								width: "30px",
								minWidth: "30px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<LogoApple
								width={"12px"}
								height={"12p"}
								style={{ fill: "#ffffff", marginTop: "4px" }}
							/>
						</Button>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default ShowcaseSignIn;
